import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MobileNavigationService {
  private readonly document = inject(DOCUMENT);
  private readonly isOpenSignal = signal(false);
  private focusOrigin: HTMLElement | null = null;

  readonly isOpen = this.isOpenSignal.asReadonly();

  open(): void {
    if (this.isOpenSignal()) {
      return;
    }

    this.rememberFocusOrigin();
    this.isOpenSignal.set(true);
  }

  close(): void {
    if (!this.isOpenSignal()) {
      return;
    }

    this.isOpenSignal.set(false);
    this.restoreFocusOrigin();
  }

  toggle(): void {
    if (this.isOpenSignal()) {
      this.close();
      return;
    }

    this.open();
  }

  private rememberFocusOrigin(): void {
    const activeElement = this.document.activeElement;
    this.focusOrigin = activeElement instanceof HTMLElement ? activeElement : null;
  }

  private restoreFocusOrigin(): void {
    const focusOrigin = this.focusOrigin;
    this.focusOrigin = null;
    this.document.defaultView?.requestAnimationFrame(() => focusOrigin?.focus({ preventScroll: true }));
  }
}
